import Modal from 'honeydew/Modal';

function EBTPaymentInfoModal({ open, setOpen }) {
    return (
        <Modal headline="EBT Payment Details" open={open} onClose={() => setOpen(false)}>
            <p className="text-body-sm mb-20">
                You can use your EBT card to pay for the total amount of SNAP-eligible items in your cart (or only some
                items, if you&apos;d like!). Before your shopping window closes, you will need to apply EBT payment by
                entering your pin and confirming the amount you want applied to the order.
            </p>
            <p className="text-body-sm mb-20">
                Any remaining order balance (including SNAP-eligible items not paid for with EBT, as well as all fees,
                delivery charges, and non-SNAP-eligible items) will be charged to your default payment method once your
                shopping window closes.
            </p>
            <p className="text-body-sm mb-20">
                If you add additional items to your cart before your shopping window closes and your SNAP-eligible total
                increases, or if you want to increase the amount of your EBT payment up to the SNAP-eligible total, you
                can update the amount paid with your EBT card at any time prior to the close of your shopping window by
                clicking the &quot;Edit&quot; button in your cart.
            </p>
            <p className="text-body-sm mb-20">
                If you remove items from your cart and your SNAP-eligible total falls below the amount you&apos;ve paid
                with your EBT card, any extra EBT payment will automatically be refunded back to your EBT card when your
                window closes.
            </p>
        </Modal>
    );
}

export default EBTPaymentInfoModal;
